import React from "react"
import { Flex, Text, Button, ColorKeys } from "@capioweb/ui-components/src"
import { urlIsInternal, urlIsToFile } from "../../utils"
import {
	StringProperty,
	LinkProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { sendCtaClickLayerPush } from "../../utils/piwikPro"

export interface CapioCtaBlockProps {
	heading: StringProperty
	preamble: StringProperty
	cta: LinkProperty
	backgroundColor?: string
}

const CapioCtaBlock: React.FC<CapioCtaBlockProps> = (props) => {
	const link = props.cta

	return (
		<Flex
			flexDirection="column"
			w={1}
			py={{ _: 3, m: 6.5 }}
			px={6.5}
			backgroundColor={props.backgroundColor as ColorKeys ?? 'blue33'}
			style={{ borderRadius: "24px" }}
		>
			<Text as="h3" variant="headline-2" mb={2}>
				{props.heading.value}
			</Text>
			<Text truncate="fourLine">{props.preamble.value}</Text>

			<Flex flexDirection="column" w={1} mt="auto" maxw={50}>
				{link &&
					link?.href &&
					(!urlIsInternal(link?.href) ? (
						<Button.Anchor
							href={link.href}
							target={link.target}
							title={link?.title}
							onClick={() => sendCtaClickLayerPush(link.text)}
						>
							{link.text}
						</Button.Anchor>
					) : (
						<Button.Link
							to={link?.href ?? "#"}
							target={urlIsToFile(link?.href) ? "_blank": link?.target}
							title={link?.title}
							onClick={() => sendCtaClickLayerPush(link?.text)}
						>
							{link?.text}
						</Button.Link>
					))}
			</Flex>
		</Flex>
	)
}

export { CapioCtaBlock }
